function Footer() {
  return (
    <footer className=" text-center my-3 ">
      <a className=" fon footer" href="mailto:ar7617@srmist.edu.in">
        Contact us for creating websites{" "}
        <i className="fa fa-envelope" aria-hidden="true" />
      </a>
    </footer>
  );
}

export default Footer;
